module.exports = __webpack_public_path__ + "img/TLF_4000.8a34afd4.svg";